<template>
  <el-dialog
    title="协议信息"
    :loading="loading"
    :visible.sync="visible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="close"
    width="1200px"
  >
    <div style="padding: 16px;">
      <dialogPanel style="padding-bottom: 1px; margin-bottom: 0px;">
        <ProtocolInfo
          v-if="applyType == 1"
          :protocolId="protocolId"
          :readOnly="true"
          mode="dialog"
          @loadSuccess="loadSuccess">
        </ProtocolInfo>
        <RefundInfo
          v-else
          :applyId="applyId"
          :applyType="applyType"
          :protocolId="protocolId"
          :readOnly="true"
          mode="dialog"
          style="margin-top: 0px;"
          @loadSuccess="loadSuccess">
        </RefundInfo>
      </dialogPanel>
    </div>
  </el-dialog>
</template>

<script>
import dialogPanel from "@/components/business/dialogPanel";
import RefundInfo from '../refund/RefundInfo'
import ProtocolInfo from './ProtocolInfo'

export default {
  components: {
    dialogPanel,
    RefundInfo,
    ProtocolInfo
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyType: {
      type: [String, Number],
      default: 1
    },
    applyId: String,
    protocolId: String
  },
  methods: {
    loadSuccess () {},
    close () {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/common/dialog.scss";
</style>


// WEBPACK FOOTER //
// src/pages/protocol/view/ProtocolInfoDialog.vue